/**
 * The words of a request: the reason a time limit's abort carries and the prompt for the dev server's editor
 * capability, which the author reads from the file the dev server keeps.
 */
export const REQUEST = {
  tookTooLong: "The request took too long.",
  capabilityPrompt: "Enter the editor capability (on the dev server's machine: cat ~/.config/odysseytales/editor-capability)",
} as const;
